import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from "./authService.service";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {GlobalState} from '../../../global.state';
import { MasterRepo } from "../../repositories/index";
@Injectable()
export class CanActivateTeam implements CanActivate{
    viewPermission:Array<string>=[];
    constructor(private gblstate:GlobalState, private _authService: AuthService, private router : Router, private masterService:MasterRepo){
      this.viewPermission = gblstate.getGlobalSetting("View-Permission")||[];
    }

    menuRight(menuId:string){
      var role = this._authService.getRole;
      if(role && role.menuRights)
        return role.menuRights.find(x=>x.menuId === menuId)
      else 
        return null
    }

    canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
    //return true;    
    var LoggedIn = this._authService.getAuth()
    var role = this.menuRight(route.routeConfig.path)
    
    if (!(LoggedIn && LoggedIn.profile)) {
      this.router.navigate(['login']);
      return false;
    }
    else if(role && role.hidden){
      return false;
    }
    else {
      var sub = this.masterService.checkUserValid().subscribe(res => {
        if (res == false) {
          console.log({ checkLogin1: false });
          this.router.navigate(['login']);
          return false;
        }
      })
    }
    return true;
  }
}